/* Formatting helpers local to Account Monitoring. */

// Formats `send.dailyResetAt` (a raw ISO 8601 string) as a local date/time for the
// "resets at" line, e.g. "Aug 11, 3:45 PM". Returns '' for a missing/invalid timestamp
// so the caller can omit the line rather than render "Invalid Date".
export const fmtResetAt = (iso) => {
  if (!iso) return ''
  const date = new Date(iso)
  if (Number.isNaN(date.getTime())) return ''
  return date.toLocaleString([], { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })
}

// A null count means "could not read this mailbox", not zero. Rendering it as 0 invents a
// fact — "sent nothing" and "we could not ask" are different operationally, and the second
// is the one someone has to act on — so everything nullish becomes an em dash.
export const fmtCount = (n) => (n === null || n === undefined ? '—' : Number(n).toLocaleString())

// Spelled out rather than "mailbox(es)": badge text styled with text-transform capitalize
// renders that as "Mailbox(Es)".
export const pluralMailboxes = (n) => `${n} ${n === 1 ? 'mailbox' : 'mailboxes'}`
